import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { FICPartiesInvolvedSectionProps, FICPartiesSectionRef } from "./FICPartyInvolvedSection";
import { getPotentialPerpetrators, getRelationshipsForStakeholderIds } from "../../../../features/stakeholder/logic/stakeholderSlice";
import { useAppDispatch, useAppSelector } from "../../../../app/store";
import { UpdateStakeholderRequest } from "../../../../api/stakeholders";
import { useParams } from "react-router-dom";
import { updateStakeholder } from "../../../../features/stakeholder/logic/stakeholderThunks";
import { FICPartyInvolvedCard } from "../../components/fic/FICPartyCard";
import { RELATED_AS_LABELS } from "../../../../api/stakeholder_relationships";


export const FICPartiesInvolvedSectionV2 = forwardRef<FICPartiesSectionRef, FICPartiesInvolvedSectionProps>(({ onNotifyChange }, ref) => {
    const potentialPerpetrators = useAppSelector(getPotentialPerpetrators);
    const stakeholderRelationships = useAppSelector(
        (state) => getRelationshipsForStakeholderIds(state, potentialPerpetrators.map(stakeholder => stakeholder.stakeholder_id))
    )

    const [stakeholderChanges, setStakeholderChanges] = useState<Record<string, UpdateStakeholderRequest>>({});
    const [resetKey, setResetKey] = useState(0);

    const getStakeholderRelatedAs = (stakeholderId: string) => {
        return Array.from(new Set(stakeholderRelationships[stakeholderId].map((r) => RELATED_AS_LABELS[r.related_as]))).join(", ")
    }

    const dispatch = useAppDispatch();


    const { id: case_id } = useParams<{ id: string }>();

    useImperativeHandle(ref, () => ({

        reset: () => {
            setStakeholderChanges({});
            setResetKey((prev) => prev + 1);
        },

        hasChanges: () => Object.keys(stakeholderChanges).length > 0,
        
        save: async () => {
            if (!case_id) return;


            if(Object.keys(stakeholderChanges).length > 0) {
                await Promise.all(
                    Object.entries(stakeholderChanges).map(([stakeholderId, request]) => (dispatch(
                        updateStakeholder({caseId: case_id, stakeholderId: stakeholderId, request: request})
                    )))
                )

                setStakeholderChanges({});
            }
        },
    }));

    const handleFraudStatusChange = (stakeholderId: string, value: "fraud" | "not-fraud") => {
        setStakeholderChanges((prev) => ({
            ...prev,
            [stakeholderId]: { ...prev[stakeholderId], is_classified_fraud: value === "fraud" },
        }));
    };

    const handleGenerateROChange = (stakeholderId: string, checked: boolean) => {
        setStakeholderChanges((prev) => ({
            ...prev,
            [stakeholderId]: { ...prev[stakeholderId], is_ro_applicable: checked },
        }));
    };

    useEffect(() => {
        onNotifyChange();
    }, [stakeholderChanges, onNotifyChange]);

        return (
        <div key={resetKey}>
            {potentialPerpetrators.map((stakeholder) => (
                <FICPartyInvolvedCard
                    key={stakeholder.stakeholder_id}
                    partyName={stakeholder.name}
                    partyType={getStakeholderRelatedAs(stakeholder.stakeholder_id)}
                    fraudStatus={stakeholderChanges[stakeholder.stakeholder_id]?.is_classified_fraud !== undefined
                        ? stakeholderChanges[stakeholder.stakeholder_id].is_classified_fraud ? "fraud" : "not-fraud"
                        : stakeholder.is_classified_fraud === true ? "fraud" :stakeholder.is_classified_fraud === false ? "not-fraud" : undefined
                    }
                    generateRO={stakeholderChanges[stakeholder.stakeholder_id]?.is_ro_applicable !== undefined
                        ? stakeholderChanges[stakeholder.stakeholder_id]?.is_ro_applicable
                        : stakeholder.is_ro_applicable
                    }
                    generateRODisabled={stakeholder.is_ro_applicable === true}
                    onFraudStatusChange={(value) => handleFraudStatusChange(stakeholder.stakeholder_id, value)}
                    onGenerateROChange={(checked) => handleGenerateROChange(stakeholder.stakeholder_id, checked)}
                />
            ))}
        </div>
        );
});

FICPartiesInvolvedSectionV2.displayName = "FICPartiesInvolvedSectionV2";